import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Constants } from '../../constants';

/*
  Generated class for the PacientesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PacientesProvider {
  data: any;


  constructor(public http: HttpClient) {
    this.data = null;
  }

  getPacientes() {

    if (this.data) {
      return Promise.resolve(this.data);
    }

    return new Promise(resolve => {

      this.http.get(Constants.hostApiNode + '/api/Patients') //'http://192.168.1.39:3000/api/Patients')
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        });
    });



  }

  find(filter: string) {

    if (this.data) {
      return Promise.resolve(this.data);
    }

    return new Promise(resolve => {

      this.http.get('http://192.168.1.39:3000/api/Patients/' + filter)
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        });
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/pacientes/pacientes.ts